import React from 'react';
import { Link } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import { siteData } from '../data/content';

const Footer = () => {
  return (
    <footer className="bg-slate-900 text-slate-300 py-12 border-t border-slate-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          
          {/* Brand & Intro */}
          <div>
            <div className="flex items-center space-x-2 mb-4">
              <SafeIcon name="Navigation" className="text-3xl text-blue-400" />
              <span className="font-bold text-xl text-white">宜蘭賞鯨龜山島快樂遊</span>
            </div>
            <p className="text-sm leading-relaxed mb-4">
              以最優質及最貼心的專人服務，帶您探索最神秘的蘭陽之星龜山島，觀看全世界最神奇的海底火山牛奶海。
            </p>
            <div className="flex space-x-4">
              <SafeIcon name="Facebook" className="text-2xl hover:text-blue-400 cursor-pointer transition-colors" />
              <SafeIcon name="Instagram" className="text-2xl hover:text-pink-400 cursor-pointer transition-colors" />
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold text-white mb-4 border-b border-slate-700 pb-2 inline-block">快速導覽</h3>
            <ul className="space-y-2">
              <li><Link to="/" className="hover:text-blue-400 transition-colors">首頁</Link></li>
              <li><Link to="/packages" className="hover:text-blue-400 transition-colors">套裝行程</Link></li>
              <li><Link to="/news" className="hover:text-blue-400 transition-colors">最新消息</Link></li>
              <li><Link to="/contact" className="hover:text-blue-400 transition-colors">線上客服與登島申請</Link></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold text-white mb-4 border-b border-slate-700 pb-2 inline-block">聯絡資訊</h3>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start space-x-3">
                <SafeIcon name="Phone" className="text-xl text-blue-400 mt-1 flex-shrink-0" />
                <div>
                  <p>主要客服: {siteData.mobile1} (吳先生)</p>
                  <p>備用客服: {siteData.mobile2}</p>
                  <p>市話: {siteData.phone}</p>
                </div>
              </li>
              <li className="flex items-center space-x-3">
                <SafeIcon name="MessageCircle" className="text-xl text-green-400 flex-shrink-0" />
                <span>LINE ID: {siteData.lineId}</span>
              </li>
              <li className="flex items-center space-x-3">
                <SafeIcon name="Mail" className="text-xl text-blue-400 flex-shrink-0" />
                <span>{siteData.email}</span>
              </li>
            </ul>
          </div>

        </div>

        <div className="mt-12 pt-8 border-t border-slate-800 text-center text-sm text-slate-500">
          <p>© {new Date().getFullYear()} 宜蘭賞鯨龜山島快樂遊旅客服務中心. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;